import { css, Interpolation, Theme } from '@emotion/react'
import { HTMLAttributes, ReactNode } from 'react'

interface GridProps extends HTMLAttributes<HTMLDivElement> {
    direction?: 'column' | 'row'
    wrap?: 'wrap' | 'nowrap'
    children: ReactNode
    overrides?: Interpolation<Theme>
    ref?: any
}

const basicGridStyles = css({
    display: 'flex',
})

const gridColumn = css({
    flexDirection: 'column',
})
const gridRow = css({
    flexDirection: 'row',
})

const gridWrap = css({
    flexWrap: 'wrap',
})
const gridNoWrap = css({
    flexWrap: 'nowrap',
})

const FlexGrid = (props: GridProps) => {
    const {
        direction = 'column',
        wrap = 'nowrap',
        children,
        overrides,
        ...rest
    } = props
    return (
        <div
            css={[
                basicGridStyles,
                direction === 'column' ? gridColumn : gridRow,
                wrap === 'nowrap' ? gridNoWrap : gridWrap,
                overrides,
            ]}
            {...rest}
        >
            {children}
        </div>
    )
}

export default FlexGrid
